/** Office documents store these lowercase keys. The main office is always "primary". */
const OFFICE_MEMBERSHIP_TYPES = new Set([
  "primary",
  "multiple",
  "secondary",
  "regional",
]);

export function isOfficeMembershipType(membershipType: unknown): boolean {
  return OFFICE_MEMBERSHIP_TYPES.has(String(membershipType ?? "").trim());
}

type SelectedFirmReloadInput = {
  id?: string;
  membershipType?: unknown;
  websiteUrl?: unknown;
  firmOverview?: unknown;
};

/**
 * True when Redux holds a list/office stub instead of the firm document.
 * Those stubs copy the office membershipType (main office = "primary").
 */
export function selectedFirmNeedsDocumentReload(
  firm: SelectedFirmReloadInput | undefined,
  firmId: string,
): boolean {
  if (!firm?.id || firm.id !== firmId) {
    return true;
  }
  if (isOfficeMembershipType(firm.membershipType)) {
    return true;
  }
  if (firm.websiteUrl == null && firm.firmOverview == null) {
    return true;
  }
  return false;
}
